import React from 'react';
import { ChevronRight, FileText, Monitor, Wifi, WifiOff, Clock, CheckCircle, XCircle } from 'lucide-react';
import { Button } from './button';
import { Card, CardContent, CardHeader, CardTitle } from './card';
import { useRaynetConnection } from '../../hooks/useRaynet';
interface SidePanelProps {
  isOpen: boolean;
  onToggle: () => void;
  isFormSaved: boolean;
  isSaving: boolean;
  lastSaved: Date | null;
  onContinueForm: (formId: string) => void;
}

export const SidePanel: React.FC<SidePanelProps> = ({
  isOpen,
  onToggle,
  isFormSaved,
  lastSaved,
  onContinueForm
}) => {
  const { data: isOnline } = useRaynetConnection();

  const formatLastSaved = (date: Date | null) => {
    if (!date) return 'Nikdy';
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    if (diffMinutes < 1) {
      return 'Právě teď';
    } else if (diffMinutes < 60) {
      return `před ${diffMinutes} minutami`;
    } else {
      const diffHours = Math.floor(diffMinutes / 60);
      return `před ${diffHours} hodinami`;
    }
  };

  return (
    <div className={`fixed top-0 right-0 h-full z-40 transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'} w-80 max-w-full bg-white shadow-lg border-l border-gray-200 flex flex-col`}>
      <div className="flex items-center justify-between px-4 py-2 border-b">
        <div className="flex items-center gap-2">
          <Monitor className="h-5 w-5 text-gray-500" />
          <span className="font-semibold text-sm">Stav systému</span>
        </div>
        <Button variant="ghost" size="icon" onClick={onToggle} aria-label="Zavřít panel">
          <ChevronRight className="h-5 w-5" />
        </Button>
      </div>
      <Card className="m-4">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <FileText className="h-4 w-4 text-gray-500" />
            Formulář
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2 mb-2">
            {isFormSaved ? (
              <CheckCircle className="h-4 w-4 text-green-600" />
            ) : (
              <XCircle className="h-4 w-4 text-yellow-600" />
            )}
            <span className="text-xs">
              {isFormSaved ? 'Uloženo' : 'Neuloženo'}
            </span>
          </div>
          <div className="flex items-center gap-2 mb-2">
            <Clock className="h-4 w-4 text-gray-500" />
            <span className="text-xs text-gray-500">
              Poslední aktivita: {formatLastSaved(lastSaved)}
            </span>
          </div>
          <div className="flex items-center gap-2 mb-2">
            {isOnline ? (
              <Wifi className="h-4 w-4 text-green-600" />
            ) : (
              <WifiOff className="h-4 w-4 text-red-600" />
            )}
            <span className="text-xs">
              {isOnline ? 'Raynet API: Online' : 'Raynet API: Offline'}
            </span>
          </div>
        </CardContent>
      </Card>
      <div className="px-4 pb-4">
        <Button variant="outline" className="w-full" onClick={() => onContinueForm('show-forms-list')}>
          <FileText className="h-4 w-4 mr-2" />
          Moje formuláře
        </Button>
      </div>
    </div>
  );
}; 